import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, money } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed | expired
  const [info, setInfo] = useState(null);
  const { clear } = useCart();
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setState("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (data.status === "expired") { setState("expired"); return; }
        if (attempts >= 6) { setState("failed"); return; }
        attempts++; setTimeout(poll, 2000);
      } catch { setState("failed"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-[700px] mx-auto px-5 pt-44 pb-40 min-h-screen text-center">
      {state === "checking" && (<><Loader2 className="mx-auto text-cyan animate-spin mb-6" size={48} /><h1 className="font-display text-4xl mb-3">Confirming payment…</h1><p className="text-white/50">Hold tight while we verify with Stripe.</p></>)}
      {state === "paid" && (<><CheckCircle2 className="mx-auto text-cyan mb-6" size={56} /><h1 className="font-display text-5xl mb-4">Order confirmed</h1><p className="text-white/60 mb-2">Thank you — your payment of {info ? money((info.amount_total || 0) / 100) : ""} was successful.</p><p className="text-white/40 text-sm mb-8">We'll be in touch to arrange safe livestock shipping.</p><Link to="/shop" className="btn-pill btn-solid inline-flex">Continue shopping</Link></>)}
      {(state === "failed" || state === "expired") && (<><XCircle className="mx-auto text-reefpink mb-6" size={56} /><h1 className="font-display text-4xl mb-4">{state === "expired" ? "Session expired" : "Payment not completed"}</h1><p className="text-white/50 mb-8">No charge was made. You can try checking out again.</p><Link to="/cart" className="btn-pill btn-pink inline-flex">Back to cart</Link></>)}
    </div>
  );
}
